import styled from 'styled-components'
import { CircularProgress } from '@mui/material'

interface Props {
  size?: number
}

const Spinner = styled(CircularProgress)`
  color: ${(props) => props.theme.palette.primary.main};
`

export default function LoadingSpinnerGreen({ size }: Props): JSX.Element {
  return <Spinner size={size || 24} />
}
